import { t } from '../../shared/i18n/index.js';

/** Desktop views; stale saved preferences fall back without changing map data. */
const VIEW_NAMES = new Set([
  'dashboard', 'bubble', 'mindmap', 'gantt', 'kanban', 'routines', 'notes', 'markdown',
]);

export function normalizeViewName(name) {
  return VIEW_NAMES.has(name) ? name : 'dashboard';
}

// Text keys of the view names (Gantt, Kanban and Markdown stay untranslated).
const VIEW_LABEL_KEYS = {
  dashboard: 'views.name.dashboard',
  bubble: 'views.name.bubbles',
  mindmap: 'views.name.mindmap',
  gantt: 'views.name.gantt',
  kanban: 'views.name.kanban',
  routines: 'views.name.routines',
  notes: 'common.notes',
  markdown: 'views.name.markdown',
};

/** A view's name as shown to the user, in the current language. */
export function viewLabel(name) {
  const key = VIEW_LABEL_KEYS[name];
  return key ? t(key) : name;
}
